import { func } from 'prop-types';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import sty from '../styles/Roles.module.css';

/**
 * @component RoleButtons
 * @param { Object } props
 * @param { function } props.onSave
 * @param { function } props.onReset
 * @param { function } props.onCreate
 * @returns { JSX.Element }
 */
function RoleButtons(props) {
	return (
		<section className={sty.role_btns_section}>
			<Tooltip arrow title="Create a new role" placement="right-start">
				<IconButton component="div" onClick={props.onCreate}>
					<AddCircleOutlineOutlinedIcon />
				</IconButton>
			</Tooltip>
			<div className={sty.role_btns_btns}>
				<Button
					className={sty.role_btns_btn}
					variant="outlined"
					size="small"
					color="sds"
					onClick={props.onSave}
				>
					SAVE
				</Button>
				<Button
					className={sty.role_btns_btn}
					variant="outlined"
					size="small"
					color="sds"
					onClick={props.onReset}
				>
					RESET
				</Button>
			</div>
		</section>
	);
}

RoleButtons.propTypes = {
	onSave: func,
	onReset: func,
	onCreate: func,
};

export default RoleButtons;
